import { intoIterable } from '../../../iterator/shared/iterator.js';
import { Some, None } from '../../../option/shared/option.js';
import '../../../result/shared/result.js';

/**
 * Класс для работы с HTTP Заголовками.
 *
 * Внутри заголовки хранятся в виде Map, так как в браузере
 * используется XMLHttpRequest и нет возможности разом установить
 * все заголовки.
 *
 * @export
 * @class HTTPHeaders
 */
class HTTPHeaders extends Headers {
    #size = 0;
    constructor(init) {
        super();
        if (init) {
            this.setHeaders(init);
        }
    }
    get size() {
        return this.#size;
    }
    get isEmpty() {
        return this.#size === 0;
    }
    set = (name, value) => {
        if (!this.has(name)) {
            this.#size++;
        }
        super.set(name, value);
    };
    append = (name, value) => {
        if (!this.has(name)) {
            this.#size++;
        }
        super.append(name, value);
    };
    delete = (name) => {
        if (this.has(name)) {
            this.#size--;
        }
        super.delete(name);
    };
    getHeader(header) {
        const value = this.get(header);
        return value !== null ? Some(value) : None();
    }
    setHeaders(headers) {
        for (const [k, v] of intoIterable(headers)) {
            if (Array.isArray(v)) {
                v.forEach(v => this.append(k, v));
            }
            else {
                this.set(k, v === undefined ? '' : v);
            }
        }
    }
    toIncomingHeaders() {
        const result = {};
        for (const [k, v] of this.entries()) {
            if (result[k]) {
                if (Array.isArray(result[k])) {
                    result[k].push(v);
                }
                else {
                    result[k] = [result[k], v];
                }
            }
            else {
                result[k] = v;
            }
        }
        return result;
    }
    toArray() {
        return Array.from(this.entries());
    }
}
function isHTTPHeaders(raw) {
    return (!Array.isArray(raw) &&
        typeof raw === 'object' &&
        typeof raw['getHeader'] === 'function' &&
        typeof raw['setHeaders'] === 'function');
}

export { HTTPHeaders, isHTTPHeaders };
//# sourceMappingURL=Headers.js.map
